/**
 * Page lifecycle: bfcache restore and visibility.
 *
 * RULE (PWA / Mini App): Do not use beforeunload or unload listeners anywhere
 * in the webapp. They prevent the page from being put in bfcache, so after
 * long background (e.g. screen lock) the tab will fully reload instead of
 * restoring in-place. See docs/PWA.md § Bfcache.
 */

export const BFCACHE_RESTORE_EVENT = "app:bfcache-restore";

function dispatchRestore() {
  window.dispatchEvent(new CustomEvent(BFCACHE_RESTORE_EVENT));
}

export function initLifecycle(): void {
  if (typeof window === "undefined") return;

  // Bfcache restore: fires when page is restored from back/forward cache
  window.addEventListener("pageshow", (event: PageTransitionEvent) => {
    if (event.persisted) dispatchRestore();
  });

  // Visibility change: fires when tab becomes visible (e.g. after screen unlock)
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") dispatchRestore();
  });
}
